import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import CloseIcon from '../../../assets/icons/Close';
import NotificationImg from '../../../assets/notification.svg';
import { DSTheme } from '../../../styles/themes/types';

type NotificationModalProps = {
  onClose: () => void;
  title: string;
  paragraphs: string[];
};

const useStyles = makeStyles((theme: DSTheme) => ({
  wrapper: {
    position: 'relative',
    display: 'grid',
    gridGap: '40px',
    placeItems: 'center',

    borderRadius: '16px',
    width: '566px',
    padding: '32px',

    backgroundColor: theme.palette.background.elevation1,
    color: theme.palette.text.primary,
    textAlign: 'center',
  },
  closeButton: {
    position: 'absolute',
    right: '32px',
    top: '32px',
    cursor: 'pointer',
  },
}));

const NotificationModal: React.FC<NotificationModalProps> = ({
  onClose,
  paragraphs = [],
  title = '',
}) => {
  const classes = useStyles();
  const theme = useTheme();

  return (
    <div className={classes.wrapper}>
      <div>
        <div className={classes.closeButton} title="close" onClick={onClose}>
          <CloseIcon stroke={theme.palette.text.primary} />
        </div>
        <Typography variant="subtitle1">{title}</Typography>
      </div>

      <img src={NotificationImg} alt="Notification" />

      {paragraphs.map((para) => (
        <Typography key={para}>{para}</Typography>
      ))}
    </div>
  );
};

export default NotificationModal;
